<template>
    <div class="col-12 mt20" itemprop="review" itemscope itemtype="https://schema.org/Review">
        <star-rating
            :increment="0.5"
            :rating="review.stars"
            :read-only="true"
            :star-size="15"
            :show-rating="false"
            active-color="#ff9b00">
        </star-rating>
        <span itemprop="reviewRating" itemscope itemtype="https://schema.org/Rating" class="d-none">
            <span itemprop="ratingValue" v-text="review.stars"></span>
            <span itemprop="worstRating">1</span>
            <span itemprop="bestRating">5</span>
        </span>
        <span itemprop="author" class="col-12 title-7 blueDarkColor mt10 boldFont fontSmooth">{{ review.name }}</span>
        <h3 itemprop="name" v-if="review.title != ''" class="col-12 title-8 blueDarkColor mt10 fontSmooth">{{ review.title }}</h3>
        <div itemprop="description" class="paragraph small col-12 mt10">
            <span v-if="showFullReview || review.content.length < reviewLength">{{ review.content }}</span>
            <span v-else>
                {{ review.content.slice(0, reviewLength).trim() }}..<br>
                <a @click.prevent="enableFullReview" href="#">{{ label('shop.reviews.read_more') }}..</a>
            </span>
        </div>
    </div>
</template>

<script>
import translations from "../mixins/translations";
export default {
    name: "Review",
    mixins: [translations,],
    props: {
        review: {
            required: true,
            type: Object
        }
    },
    data: function () {
        return {
            showFullReview: false,
            reviewLength: 360,
        }
    },
    methods: {
        enableFullReview(){
            this.showFullReview = true;
        }
    }
}
</script>
